export default "__VITE_ASSET__C014YDN5__"